module.exports = __webpack_public_path__ + "img/coin.52f6279e.svg";